class DomUtil {

    constructor () {}

    static isDescendant(parent: Element | null, child: Element | null): boolean {
        return !!(parent && child?.parentNode && parent == child.parentNode);
    }

    static getElement(selector: string, context?: any): NodeListOf<Element> {
        return (typeof context === 'object' ? context : document).querySelectorAll(selector);
    }

    static hasClass(element: Element, className: string): boolean {
        if (element.classList) {
            return element.classList.contains(className);
        }

        return new RegExp('(^| )' + className + '( |$)', 'gi').test(element.className);
    }

    static addClass(element: Element, className: string): void {
        if (!DomUtil.hasClass(element, className)) {
            element.className += ' ' + className;
        }
    }

    static removeClass(element: Element, className: string): void {
        if (element.classList) {
            element.classList.remove(className);
        } else {
            element.className = element.className.replace(new RegExp('(^|\\b)' + className.split(' ').join('|') + '(\\b|$)', 'gi'), ' ');
        }
    }

    static clientWidth(element: any): number | null {
        if(element) {
            // Native node element
            if (element.nodeName) {
                return element.clientWidth;
            }

            if(element[0]) {
                return element[0].clientWidth;
            }
        }

        return null;
    }

    static clientHeight(element: any): number | null {
        if (element) {
            // Native node element
            if (element.nodeName) {
                return element.clientHeight;
            }

            if(element[0]) {
                return element[0].clientHeight;
            }
        }

        return null;
    }

    static boundingClientRect(element: any): DOMRect | null {
        let rect: DOMRect | null = null;
        if (element) {
            // Native node element
            if (element.nodeName) {
                rect = element.getBoundingClientRect();
            } else if(element[0]) {
                rect = element[0].getBoundingClientRect();
            }

            // IE8 polyfill for missing dimension support
            if (rect && (typeof rect.width === 'undefined' || typeof rect.height === 'undefined')) {
                // ClientRect object manipulation prohibited. Create new to add width and height
                rect = {
                    top: rect.top,
                    right: rect.right,
                    bottom: rect.bottom,
                    left: rect.left,
                    width: this.clientWidth(element) || 0,
                    height: this.clientHeight(element) || 0,
                    x: rect.x || rect.left,
                    y: rect.y || rect.top,
                    toJSON: rect.toJSON
                } as DOMRect;
            }
        }
        return rect;
    }

    static getSVGtextElementsByProximity(target: Element, basedOnSelector: string, overlappingSelector: string = 'text', opts: {x: number, y: number} = {x: 30, y: 20}): Element[] {
        // Find overlapping SVG text elements based on x and y values (through proximity thresholds).
        let elements: Element[] = [];
        let predicateElements = target.querySelectorAll(basedOnSelector);
        let subjectElements = target.querySelectorAll(overlappingSelector);

        if (!predicateElements || !subjectElements) return elements;

        let mX: number, mY: number, tX: number, tY: number, xDiff: number, yDiff: number;
        for (let predicate of predicateElements) {
            mX = parseFloat(predicate.getAttribute('x') || '0');
            mY = parseFloat(predicate.getAttribute('y') || '0');
            for (let suspect of subjectElements) {
                tX = parseFloat(suspect.getAttribute('x') || '0');
                tY = parseFloat(suspect.getAttribute('y') || '0');
                xDiff = mX - tX;
                yDiff = mY - tY;

                if (Math.abs(xDiff) < opts.x && Math.abs(yDiff) < opts.y) {
                    elements.push(suspect);
                }
            }
        }

        return elements;
    }
}

export default DomUtil;
